export interface NavItemProps {
  id: string;
  messageId: string;
  title: string;
  icon?: string;
  exact?: boolean;
  url?: string;
  type?: string;
  count?: number;
  color?: string;
  auth?: string[];
  children?: NavItemProps[] | NavItemProps;
}

const routesConfig: NavItemProps[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    messageId: "sidebar.adminDashboard",
    type: "item",
    icon: "/assets/images/patientsImages/dashboard.png",
    url: "/dashboard",
  },
  {
    id: "practitionerapproval",
    title: "Practitioner Approval",
    messageId: "sidebar.practitionerApproval",
    type: "item",
    icon: "/assets/images/patientsImages/practitionerApproval.png",
    url: "/practitioner-approval",
  },
  {
    id: "templates",
    title: "Templates",
    messageId: "sidebar.templates",
    type: "collapse",
    icon: "/assets/images/patientsImages/billingPayments.png",
    children: [
      {
        id: "letterstemplates",
        title: "Letters Templates",
        messageId: "sidebar.lettersnotes",
        type: "item",
        url: "/templates",
      },
      {
        id: "questionnaire",
        title: "Questionnaires",
        messageId: "sidebar.questionnaire",
        type: "item",
        url: "/questionnaires",
      },
      {
        id: "faq",
        title: "FAQ",
        messageId: "sidebar.faq",
        type: "item",
        url: "/faqs",
      },
      {
        id: "blogs",
        title: "BLOGS",
        messageId: "sidebar.blogs",
        type: "item",
        url: "/blogs",
      },
      // {
      //   id: 'privacy',
      //   title: 'Privacy',
      //   messageId: 'sidebar.privacy',
      //   type: 'item',
      //   url: '/privacy-policy-list'
      // },
      // {
      //   id: 'termsandconditions',
      //   title: 'Terms & Conditions',
      //   messageId: 'sidebar.tc',
      //   type: 'item',
      //   url: '/tc-List'
      // },
    ],
  },
  {
    id: "appointments",
    title: "Appointments",
    messageId: "sidebar.adminAppointments",
    type: "item",
    icon: "/assets/images/patientsImages/appointments.png",
    url: "/appointments",
  },

  {
    id: "referrals",
    title: "Referrals",
    messageId: "sidebar.referrals",
    type: "collapse",
    icon: "/assets/images/patientsImages/referrals.png",
    //  url: '/referrals',
    children: [
      {
        id: "oaktreeReferral",
        title: "Oaktree Referral",
        messageId: "sidebar.oaktreeReferral",
        type: "item",
        //icon: '/assets/images/patientsImages/referrals.png',
        url: "/oaktree-referral",
      },
      {
        id: "selfReferral",
        title: "Self Referral",
        messageId: "sidebar.selfReferral",
        type: "item",
        //icon: '/assets/images/patientsImages/referrals.png',
        url: "/self-referral",
      },
      {
        id: "thirdPartyReferral",
        title: "Third Party Referral",
        messageId: "sidebar.thirdPartyReferral",
        type: "item",
        // icon: '/assets/images/patientsImages/referrals.png',
        url: "/thirdparty-referral",
      },
    ],
  },
  {
    id: "patientsList",
    title: "Patient Records",
    messageId: "sidebar.patientsList",
    type: "item",
    icon: "/assets/images/patientsImages/security.png",
    url: "/patient-record-list",
  },
  {
    id: "communications",
    title: "Communications",
    messageId: "sidebar.communications",
    type: "collapse",
    icon: "/assets/images/patientsImages/communications.png",
    children: [
      // {
      //   id: "websiteComm",
      //   title: "Website Communication",
      //   messageId: "sidebar.websiteCommunication",
      //   type: "item",
      //   url: "/website-communication",
      // },
      // {
      //   id: "adminComm",
      //   title: "Admin Communication",
      //   messageId: "sidebar.adminCommunication",
      //   type: "item",
      //   url: "/admin-communication",
      // },
      // {
      //   id: "organisationComm",
      //   title: "Organisation Communication",
      //   messageId: "sidebar.organisationCommunication",
      //   type: "item",
      //   url: "/organisation-communication",
      // },
      // {
      //   id: "feedbackComm",
      //   title: "Feedback Communication",
      //   messageId: "sidebar.feedbackCommunication",
      //   type: "item",
      //   url: "/feedback-communication",
      // },
      {
        id: "notifiactionsComm",
        title: "Notifications",
        messageId: "sidebar.notifiactionsCommunication",
        type: "item",
        url: "/notifications-communication",
      },
      // {
      //   id: "tasksComm",
      //   title: "Tasks",
      //   messageId: "sidebar.tasksCommunication",
      //   type: "item",
      //   url: "/tasks-communication",
      // },
    ],
  },
  {
    id: "taskPerm",
    title: "Task",
    messageId: "sidebar.task",
    type: "collapse",
    icon: "/assets/images/patientsImages/tasklist.png",
    children: [
      {
        id: "taskList",
        title: "Task List",
        messageId: "sidebar.taskList",
        type: "item",
        url: "/task",
      },
      {
        id: "createPatientTask",
        title: "Create Patient Task",
        messageId: "sidebar.createPatientTask",
        type: "item",
        url: "/task-create-patient",
      },
      {
        id: "createPractitionerTask",
        title: "Create Practitioner Task",
        messageId: "sidebar.createPractitionerTask",
        type: "item",
        url: "/task-create-practitioner",
      },
      {
        id: "createAdminTask",
        title: "Create Admin Task",
        messageId: "sidebar.createAdminTask",
        type: "item",
        url: "/task-create-admin",
      },
      {
        id: "taskBin",
        title: "Task Bin",
        messageId: "sidebar.taskBin",
        type: "item",
        url: "/task-bin",
      },
    ],
  },
  {
    id: "rolesPerm",
    title: "Roles & Permission",
    messageId: "sidebar.rolesPermission",
    type: "item",
    icon: "/assets/images/patientsImages/rolesPermission.png",
    url: "/roles-permision",
  },
  {
    id: "priceSettings",
    title: "Price Settings",
    messageId: "sidebar.priceSettings",
    type: "item",
    icon: "/assets/images/patientsImages/priceSettings.png",
    url: "/price-settings",
  },
  {
    id: "partnerSettings",
    title: "Partner Settings",
    messageId: "sidebar.partnerSettings",
    type: "collapse",
    icon: "/assets/images/patientsImages/billingPayments.png",
    children: [
      {
        id: "pharmacy",
        title: "Pharmacy",
        messageId: "sidebar.pharmacy",
        type: "collapse",
        children: [
          {
            id: "pharmazone",
            title: "Pharma Zone",
            messageId: "sidebar.pharmazone",
            type: "item",
            url: "/pharma-zone",
          },
        ],
      },
    ],
  },
  {
    id: "billingpayments",
    title: "Billing",
    messageId: "sidebar.Billingpayments",
    type: "collapse",
    icon: "/assets/images/patientsImages/billingPayments.png",
    children: [
      {
        id: "patientInvoices",
        title: "Patient Invoices",
        messageId: "sidebar.patientInvoices",
        type: "item",
        url: "/patient-invoices",
      },
      {
        id: "practitionerStatements",
        title: "Practitioner Statements",
        messageId: "sidebar.practitionerStatements",
        type: "item",
        url: "/practitioner-statements",
      },
      {
        id: "patientPendingPayments",
        title: "Patient Pending Payments",
        messageId: "sidebar.patientPendingPayments",
        type: "item",
        url: "/patient-pending-payments",
      },
    ],
  },
  {
    id: "usermanagement",
    title: "User Management",
    messageId: "sidebar.userManagement",
    type: "collapse",
    icon: "/assets/images/patientsImages/manageUsers.png",
    children: [
      {
        id: "adminUsers",
        title: "Admin",
        messageId: "sidebar.userManagement.adminUsers",
        type: "item",
        url: "/user-management-adminUsers",
      },
      {
        id: "practitioner",
        title: "Practitioner",
        messageId: "sidebar.userManagement.practitioner",
        type: "item",
        url: "/user-management-practitioners",
      },
      {
        id: "patient",
        title: "Patient",
        messageId: "sidebar.userManagement.patient",
        type: "item",
        url: "/user-management-patients",
      },
      // {
      //   id: "linkedusers",
      //   title: "Linked Users",
      //   messageId: "sidebar.userManagement.linkedUsers",
      //   type: "item",
      //   url: "/user-management-linkedUsers",
      // },
      {
        id: "user",
        title: "User",
        messageId: "sidebar.userManagement.user",
        type: "item",
        url: "/user-management-user",
      },
      {
        id: "organization",
        title: "Organisation",
        messageId: "sidebar.userManagement.organization",
        type: "item",
        url: "/user-management-organisations",
      },
    ],
  },
  {
    id: "customerReviewStat",
    title: "Review & Recommondations",
    messageId: "sidebar.customerReviewStat",
    type: "item",
    icon: "/assets/images/patientsImages/reportsAnalytics.png",
    url: "/reviews-ratings",
  },

  {
    id: "reportsanalytics",
    title: "Reports & Analytics",
    messageId: "sidebar.reportsAnalytics",
    type: "collapse",
    icon: "/assets/images/patientsImages/reportsAnalytics.png",
    children: [
      {
        id: "patient",
        title: "Patient",
        messageId: "sidebar.patientStat",
        type: "item",
        url: "/patient-statistics",
      },
      // {
      //   id: "customerReviewStat",
      //   title: "Review & Recommondations",
      //   messageId: "sidebar.customerReviewStat",
      //   type: "item",
      //    url: "/reviews-ratings-reports",
      // },
      {
        id: "complaints",
        title: "Complaints",
        messageId: "sidebar.complaintsStat",
        type: "item",
        // url: "/complaints-stat",
        url: "/error-pages/coming-soon",
      },
    ],
  },
  {
    id: "settings",
    title: "Settings",
    messageId: "sidebar.adminSettings",
    type: "item",
    icon: "/assets/images/patientsImages/settings.png",
    url: "/settings",
  },
  {
    id: "site-settings",
    title: "Site Settings",
    messageId: "sidebar.siteSettings",
    type: "collapse",
    icon: "/assets/images/patientsImages/settings.png",
    children: [
      {
        id: "manage-disorder",
        title: "Manage Disorder",
        messageId: "sidebar.manageDisorder",
        type: "item",
        url: "/manage-disorder",
      },
      {
        id: "manage-gp",
        title: "Manage GP",
        messageId: "sidebar.manageGP",
        type: "item",
        url: "/manage-gp",
      },
      // {
      //   id: "manage-signposting",
      //   title: "Signposting",
      //   messageId: "sidebar.manageSignposting",
      //   type: "item",
      //   url: "/signposting",
      // },
      {
        id: "manage-leaflets",
        title: "Documents for Patient",
        messageId: "sidebar.manageLeaflets",
        type: "item",
        url: "/manage-documents",
      },
      {
        id: "manage-handbook",
        title: "Handbook",
        messageId: "sidebar.manageHandbook",
        type: "item",
        url: "/handbook",
      },
      {
        id: "tasksComm",
        title: "Manage Tasks",
        messageId: "sidebar.manageTasksCommunication",
        type: "item",
        url: "/tasks-communication",
      },

      {
        id: "cancellation-reason",
        title: "Cancellation Reason",
        messageId: "sidebar.cancellationReason",
        type: "item",
        url: "/cancellation-reason",
      },
      {
        id: "manage-document-type",
        title: "Document Type",
        messageId: "sidebar.manageDocumentType",
        type: "item",
        url: "/manage-document-type",
      },
      {
        id: "appointmentSettings",
        title: "Appointment Setting",
        messageId: "sidebar.appointmentSettings",
        type: "collapse",
        children: [
          {
            id: "appointmentTypes",
            title: "Appointment Types",
            messageId: "sidebar.appointmentTypes",
            type: "item",
            url: "/appointment-types",
          },
          // {
          //   id: "package Appointments",
          //   title: "Package Appointments",
          //   messageId: "sidebar.packageAppointments",
          //   type: "item",
          //   url: "/package-appointments",
          // },
           {
            id: "services",
            title: "services",
            messageId: "sidebar.services",
            type: "item",
            url: "/services",
          },
          // {
          //   id: "packages",
          //   title: "Packages",
          //   messageId: "sidebar.packages",
          //   type: "item",
          //   url: "/packages",
          // },
          {
            id: "packages-plan",
            title: "Packages",
            messageId: "sidebar.packagesPlan",
            type: "item",
            url: "/packages-plan",
          },
          {
            id: "Cancellation Policy",
            title: "Cancellation Policy",
            messageId: "sidebar.cancellationPolicy",
            type: "item",
            url: "/cancellation-policy",
          },
        ],
      },
      // {
      //   id: "manage-appointment-type",
      //   title: "Appointment Type",
      //   messageId: "sidebar.manageAppointmentType",
      //   type: "item",
      //   url: "/manage-appointment-type",
      // },
      // {
      //   id: "manage-appointment-group-type",
      //   title: "Appointment Group Type",
      //   messageId: "sidebar.manageAppointmentGroupType",
      //   type: "item",
      //   url: "/manage-appointment-group-type",
      // },
    ],
  },

  {
    id: "helpgroup",
    title: "Help",
    messageId: "sidebar.helpGroup",
    type: "group",
    children: [
      {
        id: "adminHelpSupport",
        title: "Help & Support",
        messageId: "sidebar.adminHelpSupport",
        type: "item",
        icon: "/assets/images/patientsImages/help.png",
        url: "/help",
      },
    ],
  },
];
export default routesConfig;
